import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, delay, tap, switchMap } from "rxjs/operators";
import { of } from "rxjs";
import { AdministrationService } from "../../service/administration.service";
import { AdministrationActions } from "../administration/administration.actions";
import { RisksActions } from "./risk.actions";
import { MessageService } from 'primeng/api';
import { ComparatorOperators, DownloadRiskQueryResponse, OperatorInput, OrderTypeInput, PagingInput, RiskFields, RiskQueryComplexInput, RiskQuerySimpleInput, RiskSimpleQueryInput, RiskSortInput } from "../../../../graphql/generated";
import { RiskCatalogueService } from "../../service/risk-catalogue.service";

@Injectable()
export class RiskEffects {
  // loadRisk$ = createEffect(
  //   (as: AdministrationService = inject(AdministrationService)) => {
  //     return this.actions$.pipe(
  //       ofType(RisksActions.loadRisks),
  //       switchMap(({ parameters, filtering, fields }) =>
  //         /** An EMPTY observable only emits completion. Replace with your own observable API request */
  //         as.getRisks(convertLazyLoadToComplexWithSortAndPage(parameters)).pipe(
  //           map((risks) => {
  //             // //console.log"Users response:", users);
  //             return RisksActions.loadRisksSuccess({
  //               risks: risks.data.riskNodesByQueryComplex,
  //               filtering,
  //               fields
  //             });
  //           }),
  //           catchError((error) => of(RisksActions.loadRisksFailure({ error })))
  //         )
  //       )
  //     );
  //   },
  //   { functional: true }
  // );

  loadRisk$ = createEffect(
    (as: RiskCatalogueService = inject(RiskCatalogueService)) => {
      return this.actions$.pipe(
        ofType(RisksActions.loadRisks),
        switchMap(({ parameters, filtering, fields }) =>
          as.getRiskCatalogue(parameters).pipe(
            map((risks) => {
              return RisksActions.loadRisksSuccess({
                risks: risks,
                filtering,
                fields
              });
            }),
            catchError((error) => of(RisksActions.loadRisksFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );


  loadRiskNames$ = createEffect(
    (as: AdministrationService = inject(AdministrationService)) => {
      return this.actions$.pipe(
        ofType(AdministrationActions.loadFiltersNames),
        mergeMap(() =>
          as.getRisksFilterNames().pipe(
            map((risks) =>
              RisksActions.loadRiskNamesSuccess({
                risks: risks.data.riskNodes
              })
            ),
            catchError((error) =>
              of(RisksActions.loadRiskNamesFailure({ error }))
            )
          )
        )
      );
    },
    { functional: true }
  );

  exportRisks$ = createEffect(
    (as: RiskCatalogueService = inject(RiskCatalogueService)) => {
      return this.actions$.pipe(
        ofType(RisksActions.exportRisks),
        mergeMap(({ parameters, timeZone }) =>
          as.exportRiskCatalogue(parameters, timeZone).pipe(
            map((risks) => {
              as.downloadFile(
                risks!.data![0]!.content,
                risks!.data![0]!.filename!
              );
              return RisksActions.exportRisksSuccess({
                risks: risks?.data as DownloadRiskQueryResponse
              });
            }),
            catchError((error) => of(RisksActions.exportRisksFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  syncronize$ = createEffect(
    (leService: AdministrationService = inject(AdministrationService), messageService: MessageService = inject(MessageService)) => {
      return this.actions$.pipe(
        ofType(RisksActions.syncronizeRisks),
        tap(() => {
          messageService.add({ summary: 'Synchronization in progress', detail: '....', severity: 'info', life: 1500 })
        }),
        mergeMap(() =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          leService.syncronizeRisks().pipe(
            delay(3000),
            map(() => {
              //lancio mS per lanciare il toast
              messageService.add({ summary: 'Synchronization completed', detail: 'the data is up to date.', severity: 'success' })
              return RisksActions.loadRisks(
                {
                  parameters: {
                    filters: [],
                    rows: 150,
                    page: 0,
                    search: "",
                    order: { sortDirection: "ASC", sortField: null }
                  }
                }
              );
            }),
            // DA RIPRISTINARE CATCH ERROR
            catchError(() => {
              messageService.add({ summary: 'Synchronization completed', severity: 'success' })
              return of(RisksActions.loadRisks(
                {
                  parameters: {
                    filters: [],
                    rows: 150,
                    page: 0,
                    search: "",
                    order: { sortDirection: "ASC", sortField: null }
                  }
                }
              )
              )
              // of(RisksActions.syncronizeRisksFailure())            
            }
            )
          )
        )
      );
    },
    { functional: true }
  );

  constructor(private actions$: Actions) { }
}


export function convertLazyLoadToComplexWithSortAndPage(parameters: any): { query: RiskQueryComplexInput, page: PagingInput, sort: RiskSortInput } {
  const query: { [key: string]: RiskSimpleQueryInput[] } = {};

  if (parameters) {

    Object.entries(parameters?.filters).forEach(([field, values]) => {
      if (values !== null && Array.isArray(values) && values.length > 0) {
        (ENUM_RISK[field as keyof typeof ENUM_RISK] || [field]).forEach((key) => {
          if (!query[field]) {
            query[field] = [];
          }
          query[field].push({
            field: key as RiskFields,
            filters: {
              operator: ComparatorOperators.Match,
              value: values
            }
          });
        })
      }
    });
  }

  const querySend: RiskQuerySimpleInput[] = [];
  Object.keys(query).forEach(key => {
    querySend.push({
      operator: OperatorInput.Or,
      query: query[key]
    })
  })

  const search: RiskQuerySimpleInput = {
    operator: OperatorInput.Or,
    query: [] as RiskSimpleQueryInput[]
  }

  if (parameters?.search && parameters?.search !== '') {
    ['riskName', 'riskCode', 'riskStatus', 'riskDescription', 'category'].forEach((field) => {
      (ENUM_RISK2[field as keyof typeof ENUM_RISK] || [field]).forEach((key) => {
        search.query?.push({
          field: key as RiskFields,
          filters: {
            operator: ComparatorOperators.Contains,
            value: parameters.search
          }
        });
      })
    });
    querySend.push({
      operator: OperatorInput.Or,
      query: search.query
    })
  }

  return {
    query: {
      operator: OperatorInput.And,
      query: querySend
    },
    sort: {
      sortField: ENUM_RISK?.[parameters?.order?.sortField as keyof typeof ENUM_RISK]?.[0] as RiskFields || "LEVEL_ONE_RISK_CODE",
      sortOrder: parameters?.order?.sortDirection === 'ASC' ? OrderTypeInput.Asc : OrderTypeInput.Desc || OrderTypeInput.Asc
    },
    page: {
      pageNo: parameters?.pa ?? 0,
      pageSize: parameters?.p ?? 10000
    }
  }
}

export const ENUM_RISK = {
  riskName: ['LEVEL_ONE_RISK_NAME', 'LEVEL_TWO_RISK_NAME', 'LEVEL_THREE_RISK_NAME'],
  riskCode: ['LEVEL_ONE_RISK_CODE', 'LEVEL_TWO_RISK_CODE', 'LEVEL_THREE_RISK_CODE'],
  riskStatus: ['LEVEL_ONE_RISK_STATUS', 'LEVEL_TWO_RISK_STATUS', 'LEVEL_THREE_RISK_STATUS'],
  riskDescription: ['LEVEL_ONE_RISK_DESCRIPTION', 'LEVEL_TWO_RISK_DESCRIPTION', 'LEVEL_THREE_RISK_DESCRIPTION'],
  category: ['LEVEL_TWO_RISK_CATEGORY'],
  riskExample: ["LEVEL_TWO_RISK_EXAMPLES", "LEVEL_THREE_RISK_EXAMPLES"]
}


export const ENUM_RISK2 = {
  riskName: ['LEVEL_ONE_RISK_NAME', 'LEVEL_TWO_RISK_NAME', 'LEVEL_THREE_RISK_NAME'],
  riskCode: ['LEVEL_ONE_RISK_CODE', 'LEVEL_TWO_RISK_CODE', 'LEVEL_THREE_RISK_CODE'],
  riskStatus: ['LEVEL_ONE_RISK_STATUS', 'LEVEL_TWO_RISK_STATUS', 'LEVEL_THREE_RISK_STATUS'],
  riskDescription: ['LEVEL_ONE_RISK_DESCRIPTION', 'LEVEL_TWO_RISK_DESCRIPTION', 'LEVEL_THREE_RISK_DESCRIPTION'],
  category: ['LEVEL_TWO_RISK_CATEGORY'],
  riskExample: ["LEVEL_TWO_RISK_EXAMPLES", "LEVEL_THREE_RISK_EXAMPLES"]
}
